import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { LangContext } from "../context/langContext"
import loadable from "@loadable/component"
import PageHero from "../components/pageHero"
import { getSearchPath } from "../utils/pathUtils"

const Search = loadable(() => import("../components/search"), { ssr: false })

const SearchPage = ({ pageContext, location }) => {
  const locale = pageContext.locale

  const i18nPaths = pageContext.locales.map(locale => {
    return {
      locale: locale,
      value: getSearchPath(locale),
    }
  })

  return (
    <Layout locale={locale} location={location} i18nPaths={i18nPaths}>
      <LangContext.Consumer>
        {t => (
          <>
            <SEO title={t.search} lang={locale} />
            <PageHero title={t.search} locale={locale}></PageHero>
          </>
        )}
      </LangContext.Consumer>

      <Search locale={locale} />
    </Layout>
  )
}

export default SearchPage
